/**
 * Bottom navigation for mobile app.
 */

interface BottomNavProps {
  activeTab: 'tasks' | 'time';
  onTabChange: (tab: 'tasks' | 'time') => void;
}

export function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  return (
    <nav className="flex-none h-16 border-t border-rule bg-surface safe-bottom">
      <div className="flex items-center justify-around h-full max-w-md mx-auto">
        <NavItem
          icon={<TasksIcon />}
          label="Tasks"
          isActive={activeTab === 'tasks'}
          onClick={() => onTabChange('tasks')}
        />
        <NavItem
          icon={<ClockIcon />}
          label="Time"
          isActive={activeTab === 'time'}
          onClick={() => onTabChange('time')}
        />
      </div>
    </nav>
  );
}

interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

function NavItem({ icon, label, isActive, onClick }: NavItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex flex-col items-center justify-center gap-1 px-6 py-2 rounded-lg
        transition-colors
        ${
          isActive
            ? 'text-accent'
            : 'text-ink-subtle hover:text-ink'
        }
      `}
    >
      <span className="w-6 h-6">{icon}</span>
      <span className="text-xs font-medium">{label}</span>
    </button>
  );
}

function TasksIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="9"
        y="3"
        width="6"
        height="4"
        rx="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
